import { cn } from "@/lib/utils";
import { EVENT_STATUS, REQUEST_STATUS, SEVERITY } from "@/lib/status";

/** Severity as dot + text. Critical/warning use colour; info stays muted. */
export const SeverityBadge = ({ severity, className, ...props }) => {
  const cfg = SEVERITY[severity] || SEVERITY.info;
  return (
    <span className={cn("inline-flex items-center gap-1.5 whitespace-nowrap text-[12px] font-medium", cfg.text, className)} {...props}>
      <span className={cn("status-dot", cfg.dotClass)} aria-hidden="true" />
      {cfg.label}
    </span>
  );
};

const quietPill = "inline-flex items-center gap-1.5 whitespace-nowrap rounded-[5px] border bg-card px-1.5 py-px text-[11px] font-medium";

export const EventStatusBadge = ({ status, className, ...props }) => {
  const cfg = EVENT_STATUS[status] || EVENT_STATUS.resolved;
  return (
    <span className={cn(quietPill, cfg.badge, className)} {...props}>
      <span className={cn("h-1.5 w-1.5 rounded-full", cfg.dot)} aria-hidden="true" />
      {cfg.label}
    </span>
  );
};

export const RequestStatusBadge = ({ status, className, ...props }) => {
  const cfg = REQUEST_STATUS[status] || REQUEST_STATUS.mottatt;
  return (
    <span className={cn(quietPill, cfg.badge, className)} {...props}>
      <span className={cn("h-1.5 w-1.5 rounded-full", cfg.dot)} aria-hidden="true" />
      {cfg.label}
    </span>
  );
};
